export const Messages = {
  org: {
    absence: {
      not_owned: "Это чужое",
      start_before_end: "Дата начала должна быть раньше даты окончания",
      cant_change_past_its_gone: "Невозможно изменить прошлое, оно уже случилось 🥲",
      cant_have_two_absences_same_day: "Уже есть что-то на этот день",
      exceeds_rolling_limit: "Слишком много удаленок за период",
      cant_set_for_self: "Должен указать руководитель",
      dayoff_exceeds_yearly_limit: "Использованы все свободные дни на этот год",
      exceeds_consecutive_dayoff_limit: "Можно взять не более двух свободных дней подряд",
    }
  }
}